module.exports = __webpack_public_path__ + "static/media/logo-slaek_3x.a7fb5dc3.png";